"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AppHooksService", {
    enumerable: true,
    get: function() {
        return AppHooksService;
    }
});
const _common = require("@nestjs/common");
const _eventemitterinterface = require("~/modules/event-emitter/event-emitter.interface");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const ALL_EVENTS = '__nc_all_events__';
let AppHooksService = class AppHooksService {
    on(event, listener) {
        const unsubscribe = this.eventEmitter.on(event, listener);
        this.listenerUnsubscribers.set(listener, unsubscribe);
        return unsubscribe;
    }
    emit(event, data) {
        this.eventEmitter.emit(event, data);
        this.eventEmitter.emit(ALL_EVENTS, {
            event,
            data: data
        });
    }
    removeListener(event, listener) {
        var _this_listenerUnsubscribers_get;
        (_this_listenerUnsubscribers_get = this.listenerUnsubscribers.get(listener)) == null ? void 0 : _this_listenerUnsubscribers_get();
        this.listenerUnsubscribers.delete(listener);
    }
    removeListeners(event) {
        return this.eventEmitter.removeAllListeners(event);
    }
    removeAllListener(listener) {
        var _this_listenerUnsubscribers_get;
        (_this_listenerUnsubscribers_get = this.listenerUnsubscribers.get(listener)) == null ? void 0 : _this_listenerUnsubscribers_get();
        this.listenerUnsubscribers.delete(listener);
    }
    onAll(listener) {
        const unsubscribe = this.eventEmitter.on(ALL_EVENTS, async (...args)=>{
            try {
                await listener(...args);
            } catch (e) {
                this.logger.error(e == null ? void 0 : e.message, e == null ? void 0 : e.stack);
            }
        });
        this.listenerUnsubscribers.set(listener, unsubscribe);
        return unsubscribe;
    }
    constructor(eventEmitter){
        this.eventEmitter = eventEmitter;
        this.logger = new _common.Logger('AppHooksService');
        this.listenerUnsubscribers = new Map();
    }
};
AppHooksService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)('IEventEmitter')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _eventemitterinterface.IEventEmitter === "undefined" ? Object : _eventemitterinterface.IEventEmitter
    ])
], AppHooksService);
